var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 79,
    viewBox: "0 0 102 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_80_588)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.03566 78.3569C20.1537 76.5681 35.0808 67.0352 42.8216 52.6363C46.9858 44.8904 49.4861 34.6845 44.5269 26.6781C40.0686 19.4804 30.3484 15.597 22.9311 20.912C15.424 26.2914 14.2023 35.8217 16.2009 44.2603C17.2239 48.5801 18.8687 52.8017 20.5214 56.9158C22.0167 60.6379 23.646 64.36 25.934 67.6736C30.7077 74.587 37.9445 79.2535 46.5834 78.811C55.3022 78.3643 63.1677 73.7116 68.6423 67.051C75.0603 59.2427 79.0028 49.5562 82.1253 40.0336C85.5533 29.579 87.582 18.7067 88.4045 7.74147C88.5677 5.56538 86.4328 3.70581 84.3688 3.70581C82.0492 3.70581 80.4969 5.55912 80.3332 7.74147C79.1692 23.2588 75.3096 39.137 68.1676 53.0263C65.0247 59.1383 60.9017 65.0445 54.7112 68.3619C49.3301 71.2455 42.6116 71.8623 37.4168 68.2613C32.4998 64.853 29.8411 58.7725 27.756 53.3771C25.3231 47.0815 21.7702 39.4114 23.965 32.5969C25.6148 27.4746 30.7472 24.5192 35.3416 28.2426C40.7145 32.5968 39.5918 40.3347 37.133 45.9698C31.4307 59.0384 18.1969 68.714 4.03566 70.2856C1.86964 70.526 0 71.9683 0 74.3213C0 76.3164 1.85542 78.5989 4.03566 78.3569Z",
    fill: "url(#paint0_linear_80_588)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.6208 27.8795C77.4984 20.5952 82.3759 13.3109 87.2534 6.02662H80.2841C84.1669 12.4333 88.0498 18.8399 91.9326 25.2466C92.4872 26.1616 93.0417 27.0766 93.5963 27.9916C94.725 29.854 97.2156 30.552 99.1178 29.4394C100.981 28.3497 101.7 25.7889 100.566 23.9178C96.6828 17.5112 92.7999 11.1045 88.9171 4.69789C88.3625 3.78289 87.808 2.86787 87.2534 1.95288C85.6166 -0.747904 81.9615 -0.552174 80.2841 1.95288C75.4065 9.23718 70.529 16.5215 65.6515 23.8058C64.4384 25.6175 65.2996 28.2747 67.0993 29.3273C69.0811 30.4865 71.4048 29.6956 72.6208 27.8795Z",
    fill: "url(#paint1_linear_80_588)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.6208 27.8795C77.4984 20.5952 82.3759 13.3109 87.2534 6.02662H80.2841C84.1669 12.4333 88.0498 18.8399 91.9326 25.2466C92.4872 26.1616 93.0417 27.0766 93.5963 27.9916C94.725 29.854 97.2156 30.552 99.1178 29.4394C100.981 28.3497 101.7 25.7889 100.566 23.9178C96.6828 17.5112 92.7999 11.1045 88.9171 4.69789C88.3625 3.78289 87.808 2.86787 87.2534 1.95288C85.6166 -0.747904 81.9615 -0.552174 80.2841 1.95288C75.4065 9.23718 70.529 16.5215 65.6515 23.8058C64.4384 25.6175 65.2996 28.2747 67.0993 29.3273C69.0811 30.4865 71.4048 29.6956 72.6208 27.8795Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_80_588",
    x1: 44.2067,
    y1: 3.70581,
    x2: 44.2067,
    y2: 78.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06D6D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_80_588",
    x1: 83.0977,
    y1: 0,
    x2: 83.0977,
    y2: 29.9727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06D6D0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_80_588"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 101.109,
    height: 78.84,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.194b6af729305c2cef9337e6195ddd95.svg";
export { ForwardRef as ReactComponent };